import React from 'react';

import { Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import LinkButton from 'app/common/components/LinkButton';
import { useAvroEvent } from 'app/developer-v3/hooks';
import {
  BASE_DOC_URL_VB,
  DEVELOPER_CLI_GUIDE_URL,
} from 'app/developer-v3/constants';

import CTA from './CTA';

type Props = {
  createAppUrl: string;
};

function CTAStart({ createAppUrl }: Props) {
  const { emitUserInteractionEvent } = useAvroEvent();

  return (
    <CTA>
      <CTA.Header>Build a Zapier integration</CTA.Header>
      <CTA.Body margin="15px 0px">
        <Text tag="p">
          Zapier’s Free Developer Platform connects your API to the web’s top
          apps. Get a step by step walk-through of a Zapier integation in our{' '}
          <Link
            href={`${BASE_DOC_URL_VB}/quickstart/how-zapier-works`}
            target="_blank"
          >
            Quick start guide
          </Link>
          .
        </Text>
      </CTA.Body>
      <LinkButton
        variant="primary"
        href={createAppUrl}
        onPress={() =>
          emitUserInteractionEvent({
            eventAction: 'click',
            interactionRawText: 'Start a Zapier Integration',
            interactionName: 'start_integration',
            interactionGoal: 'Start creating a Zapier integration using the UI',
          })
        }
      >
        Start a Zapier integration
      </LinkButton>
      <Text margin="0px 0px 0px 10px" tag="span">
        Or start your integration{' '}
        <Link href={DEVELOPER_CLI_GUIDE_URL} target="_blank">
          with the CLI
        </Link>
      </Text>
    </CTA>
  );
}

export default CTAStart;
